<template>
  <IQOS :systemDependency="'delivery'" required :title="$t('delivery.price.title')">
    <BaseTabSwitcher
      class="w-100 mt-16"
      :value="cost_type"
      @input="setCostType"
      :tabs="[
        {
          text: $t('delivery.price.type_free'),
          value: 'free',
        },
        {
          text: $t('delivery.price.type_conditional'),
          value: 'conditional',
        },
        {
          text: $t('delivery.price.type_constant'),
          value: 'constant',
          hidden_values: ['taxi']
        },
      ]"
    />

    <BaseDivider class="mt-16 mb-16" color="v1-grey-6" v-if="!isDeliveryFree" />

    <div class="conditional-options" v-if="cost_type == 'conditional'">
      <BaseUnitInput
        type="number"
        fullWidth
        class="w-100"
        :placeholder="$t('delivery.price.amount_ph')"
        @blur="onEditFinish"
        :unitPlaceholder="currency.symbol"
        v-model.number="cost_min_check"
      />

      <p class="iqos-comment qrw-paragraph-md mt-8">
        {{ $t("delivery.price.free_after") }}
      </p>

      <BaseDivider class="mt-16 mb-16" color="v1-grey-6" v-if="!isDeliveryFree" />


      <BaseTabSwitcher
        class="w-100"
        v-model="cost_conditional_type"
        :tabs="[
          {
            text: $t('delivery.price.fixed_price'),
            value: 'constant',
          },
          {
            text: $t('delivery.price.courier_price'),
            value: 'taxi',
          }
        ]"
      />
    </div>

    <div class="conditional-options" v-if="isDeliveryPaid">
      <BaseTabSwitcher
        class="w-100"
        :value="cost_type"
        @input="setCostType"
        :tabs="[
          {
            text: $t('delivery.price.fixed_price'),
            value: 'constant',
          },
          {
            text: $t('delivery.price.courier_price'),
            value: 'taxi'
          }
        ]"
      />
    </div>

    <div class="constant-price-options" v-if="isDeliveryPaid">
      <BaseUnitInput
        type="number"
        class="mt-16 w-100"
        fullWidth
        :placeholder="$t('delivery.price.amount_ph')"
        :readonly="false"
        @blur="onEditFinish"
        v-model.number="cost"
        :unitPlaceholder="currency.symbol"
        v-if="cost_type == 'constant'"
      />

      <p class="iqos-comment qrw-paragraph-md mt-16">
        {{ $t("delivery.price.courier_desc") }}
      </p>
    </div>

    <div class="conditional-price-options" v-if="isDeliveryConditional">
      <BaseUnitInput
        type="number"
        class="w-100 mt-16"
        fullWidth
        :placeholder="$t('delivery.price.amount_ph')"
        :readonly="false"
        @blur="onEditFinish"
        :unitPlaceholder="currency.symbol"
        v-if="cost_conditional_type == 'constant'"
        v-model.number="cost"
      />

      <p class="iqos-comment qrw-paragraph-md mt-16">
        {{ $t("delivery.price.courier_desc") }}
      </p>
    </div>

    <div v-if="canShowAddCostToCheckOption">
      <BaseDivider class="mt-16" color="v1-grey-6" />

      <SlideToggleRow
        class="mt-16"
        v-model="add_cost_to_check"
      >
        {{ $t("delivery.price.add_cost_to_check") }}
      </SlideToggleRow>
    </div>

    <!-- <IQOSActions :editing="editing" @edit="showEditUI" @accept="onEditFinish" @cancel="hideEditUI" /> -->
  </IQOS>
</template>

<script>
import SlideToggleRow from "@/components/SlideToggleRow.vue"

export default {
  data() {
    return {
      editing: false,

      cost: null,
      cost_type: "free",
      cost_min_check: null,
      cost_conditional_type: "constant",
      add_cost_to_check: false,

      ready: false,
    };
  },
  watch: {
    cost_conditional_type() {
      this.onEditFinish();
    },
    cost_type() {
      this.onEditFinish();
    },
    add_cost_to_check() {
      this.onEditFinish();
    },
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    onEditFinish() {
      // this.editing = false;
      if (!this.ready) return;

      if (
        this.cost_type != "constant" &&
        this.cost_conditional_type != "constant"
      ) {
        this.add_cost_to_check = false;
      }

      this.$store.commit("setDeliveryCost", {
        cost: this.cost,
        cost_type: this.cost_type,
        cost_min_check: this.cost_min_check,
        cost_conditional_type: this.cost_conditional_type,
        add_cost_to_check: this.add_cost_to_check,
      });
      this.$store.dispatch("saveCafe");

      this.$store.dispatch("auditlog/write", {
        type: "delivery_price",
        payload: {
          cost_type: this.cost_type,
        },
      });
    },
    reset() {
      if (this.cafe.delivery) {
        this.cost = this.cafe.delivery.cost || null;

        this.cost_type = this.cafe.delivery.cost_type || "free";

        this.cost_min_check = this.cafe.delivery.cost_min_check || null;

        this.cost_conditional_type =
          this.cafe.delivery.cost_conditional_type || "constant";

        this.add_cost_to_check = this.cafe.delivery.add_cost_to_check;
      }

      this.$nextTick(() => {
        this.ready = true;
      });
    },
    setCostType(arg) {
      this.cost_type = arg;
      // this.onEditFinish();
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    isDeliveryFree() {
      return this.cost_type == "free";
    },
    isDeliveryConditional() {
      return this.cost_type == "conditional";
    },
    isDeliveryPaid() {
      return this.cost_type == "constant" || this.cost_type == "taxi";
    },
    canShowAddCostToCheckOption() {
      return (
        this.cost_type == "constant" ||
        (this.cost_type == "conditional" &&
          this.cost_conditional_type == "constant")
      );
    },
    currency() {
      return this.$store.state.currency;
    },
  },
  mounted() {
    this.reset();
  },
  components: {
    SlideToggleRow
  },
};
</script>

<style>
</style>